import { render, staticRenderFns } from "./FileModalPopup.vue?vue&type=template&id=63a2219c&"
import script from "./FileModalPopup.vue?vue&type=script&lang=js&"
export * from "./FileModalPopup.vue?vue&type=script&lang=js&"
import style0 from "./FileModalPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports